<template>
  <nav :style="{backgroundColor: navColor}">
    <div class="container overflow-hidden">
      <ul>
        <li v-for="(item, i) in list" :key="i">
          <router-link :to="item.path" v-html="item.name"></router-link>
        </li>
      </ul>
      <div class="user">
        <template v-if="isLogin">
          <span v-html="username"></span>
          <router-link :to="{ path: '/login'}">退出</router-link>
        </template>
        <template v-else>
          <router-link :to="{ path: '/login'}">登录</router-link> &nbsp;&nbsp;|&nbsp;&nbsp;
          <router-link :to="{ path: '/register'}">注册</router-link>
        </template>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navigation",
  props: ['list'],
  computed: {
    isLogin() {
      return !!this.$store.state.uname
    },
    username() {
      return this.$store.state.uname
    },
    navColor() {
      return this.$store.state.head_color
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../assets/style/colors.scss";

nav {
  height: 46px;
  line-height: 46px;
  font-size: 16px;
  color: #fff;
  a {
    color: #fff;
  }
  ul {
    overflow: hidden;
    float: left;
    li {
      float: left;
      list-style: none;
      a {
        padding: 0 25px;
        line-height: 1;
        display: inline-block;
        &.router-link-exact-active {
          color: $yellow;
        }
      }
      &:not(:first-child) {
        a {
          border-left: 1px solid rgba(255,255,255,.5);
        }
      }
    }
  }
  .user {
    background: url(../assets/img/user.png) no-repeat left center;
    float: right;
    padding-left: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue